import { Action, createReducer, on } from '@ngrx/store';
import { UserState, initialState } from './state';
import {
  addProperty,
  addPropertyFailure,
  addPropertySuccess,
  addRegisterAgent,
  addRegisterAgentFailure,
  addRegisterAgentSuccess,
  addTicketReply,
  addTicketReplyFailure,
  addTicketReplySuccess,
  changePassword,
  changePasswordFailure,
  changePasswordSuccess,
  clearPayrollSubmissionDetails,
  contactAgent,
  contactAgentFailure,
  contactAgentSuccess,
  contactUs,
  contactUsFailure,
  contactUsSuccess,
  createAgentOffMarketProperty,
  createAgentOffMarketPropertyFailure,
  createAgentOffMarketPropertySuccess,
  createAgentPayrollRequestSuccess,
  createOrUpdateRentalListing,
  createOrUpdateRentalListingFailure,
  createOrUpdateRentalListingSuccess,
  deleteRentalListing,
  deleteRentalListingFailure,
  deleteRentalListingSuccess,
  createUserPassword,
  createUserPasswordFailure,
  createUserPasswordSuccess,
  createUserTicket,
  createUserTicketFailure,
  createUserTicketSuccess,
  deactivateUser,
  deactivateUserFailure,
  deactivateUserSuccess,
  deleteUserProperty,
  deleteUserPropertyFailure,
  deleteUserPropertySuccess,
  deleteUserTicket,
  deleteUserTicketFailure,
  deleteUserTicketSuccess,
  getAddedPropertyInWishListSuccess,
  getAgentAppointments,
  getAgentAppointmentsFailure,
  getAgentAppointmentsSuccess,
  getAgentByIdSuccess,
  getAgentContactQueries,
  getAgentContactQueriesFailure,
  getAgentContactQueriesSuccess,
  getAgentLeads,
  getAgentLeadsFailure,
  getAgentLeadsSuccess,
  getMarketedAgentLeads,
  getMarketedAgentLeadsFailure,
  getMarketedAgentLeadsSuccess,
  getAgentOffMarketProperties,
  getAgentOffMarketPropertiesFailure,
  getAgentOffMarketPropertiesSuccess,
  getAgentOffMarketPropertyDetails,
  getAgentOffMarketPropertyDetailsFailure,
  getAgentOffMarketPropertyDetailsSuccess,
  getAgentPayrollSubmissionDetails,
  getAgentPayrollSubmissionDetailsFailure,
  getAgentPayrollSubmissionDetailsSuccess,
  getAgentPayrollSubmissions,
  getAgentPayrollSubmissionsFailure,
  getAgentPayrollSubmissionsSuccess,
  getAgentPortfolio,
  getAgentPortfolioFailure,
  getAgentPortfolioSuccess,
  getAllRegisterAgents,
  getAllRegisterAgentsSuccess,
  getBlogByIdSuccess,
  getBlogs,
  getBlogsSuccess,
  getMapPropertiesSuccess,
  getMessagesListSuccess,
  getMessagesSuccess,
  getMlsPropertyDetails,
  getMlsPropertyDetailsFailure,
  getMlsPropertyDetailsSuccess,
  getPropertyDetailsFailure,
  getPropertyDetailsSuccess,
  getRentalListingById,
  getRentalListingByIdFailure,
  getRentalListingByIdSuccess,
  getRentalListings,
  getRentalListingsFailure,
  getRentalListingsSuccess,
  searchRentalProperties,
  searchRentalPropertiesFailure,
  searchRentalPropertiesSuccess,
  getRentalMapMarkers,
  getRentalMapMarkersFailure,
  markAsSold,
  markAsSoldSuccess,
  markAsSoldFailure,
  getRentalMapMarkersSuccess,
  getSharedOffMarketProperty,
  getSharedOffMarketPropertyFailure,
  getSharedOffMarketPropertySuccess,
  submitRentalForApproval,
  submitRentalForApprovalFailure,
  submitRentalForApprovalSuccess,
  getTicketDetails,
  getTicketDetailsFailure,
  getTicketDetailsSuccess,
  getTicketRepliesSuccess,
  getTwitterPostsSuccess,
  getInstagramPostsSuccess,
  getUserByIdSuccess,
  getUserDetails,
  getUserDetailsFailure,
  getUserDetailsSuccess,
  getUserProperties,
  getUserPropertiesFailure,
  getUserPropertiesSuccess,
  getUserPropertyDetails,
  getUserScheduledTours,
  getUserScheduledToursFailure,
  getUserScheduledToursSuccess,
  getUserTickets,
  getUserTicketsFailure,
  getUserTicketsSuccess,
  getUserWishlist,
  getUserWishlistFailure,
  getUserWishlistSuccess,
  getYoutubeVideosSuccess,
  login,
  loginFailure,
  loginSuccess,
  initiateMarketedListingPayment,
  initiateMarketedListingPaymentFailure,
  initiateMarketedListingPaymentSuccess,
  newsletterSubscribe,
  newsletterSubscribeFailure,
  newsletterSubscribeSuccess,
  resetPassword,
  resetPasswordFailure,
  resetPasswordSuccess,
  scheduleATour,
  scheduleATourFailure,
  scheduleATourSuccess,
  searchProperties,
  searchPropertiesFailure,
  searchPropertiesSuccess,
  setLoadingState,
  setMessage,
  setSearchPropertyRequest,
  signOutConfirmed,
  signUp,
  signUpFailure,
  signUpSuccess,
  updateAgentLeadStatus,
  updateAgentLeadStatusFailure,
  updateAgentLeadStatusSuccess,
  updateAgentPortfolio,
  updateAgentPortfolioFailure,
  updateAgentPortfolioSuccess,
  updateUserProfileImage,
  updateUserProfileImageFailure,
  updateUserProfileImageSuccess,
  updateUserTicketStatus,
  updateUserTicketStatusFailure,
  updateUserTicketStatusSuccess,
  uploadAgentPayrollDocumentsSuccess,
  verifyEmailOtp,
  verifyEmailOtpFailure,
  verifyEmailOtpSuccess,
  getArisMarketedProperties,
  getArisMarketedMapProperties,
  getArisMarketedPropertiesFailure,
  getArisMarketedMapPropertiesFailure,
  getArisMarketedPropertiesSuccess,
  getArisMarketedMapPropertiesSuccess,
  getArisMarketedPropertyDetails,
  getArisMarketedPropertyDetailsSuccess,
  getArisMarketedPropertyDetailsFailure,
  getPublicRentalListingById,
  getPublicRentalListingByIdSuccess,
  getPublicRentalListingByIdFailure,
  startKycIdentitySession,
  startKycIdentitySessionSuccess,
  startKycIdentitySessionFailure,
  startKycProfilePolling,
  stopKycProfilePolling,
  kycProfilePollingTimedOut,
  clearKycProfilePollingState,
  setPendingRentalSubmitAfterKyc,
  checkKycProfileStatusSuccess,
} from './actions';
import { PropertyMapItem } from 'src/app/shared/models';
const reducer = createReducer(
  initialState,
  on(
    login,
    signUp,
    addProperty,
    getAgentLeads,
    getMarketedAgentLeads,
    resetPassword,
    scheduleATour,
    changePassword,
    verifyEmailOtp,
    getUserTickets,
    addTicketReply,
    searchProperties,
    getUserWishlist,
    deleteUserTicket,
    getTicketDetails,
    createUserTicket,
    getUserProperties,
    createUserPassword,
    deleteUserProperty,
    getAgentAppointments,
    getUserPropertyDetails,
    updateUserProfileImage,
    getMlsPropertyDetails,
    contactUs,
    getUserScheduledTours,
    updateUserTicketStatus,
    addRegisterAgent,
    newsletterSubscribe,
    contactAgent,
    updateAgentLeadStatus,
    getAgentContactQueries,
    getAgentPortfolio,
    updateAgentPortfolio,
    getAgentPayrollSubmissions,
    getAgentPayrollSubmissionDetails,
    getAgentOffMarketProperties,
    getAgentOffMarketPropertyDetails,
    createAgentOffMarketProperty,
    initiateMarketedListingPayment,
    getSharedOffMarketProperty,
    createOrUpdateRentalListing,
    getRentalListings,
    getRentalListingById,
    submitRentalForApproval,
    deleteRentalListing,
    startKycIdentitySession,
    searchRentalProperties,
    getRentalMapMarkers,
    getArisMarketedProperties,
    getArisMarketedMapProperties,
    getArisMarketedPropertyDetails,
    (state): UserState => ({
      ...state,
      isLoading: true,
    }),
  ),
  on(getPublicRentalListingById, (state, { isLoading }): UserState => ({
      ...state,
      isLoading: isLoading !== undefined ? isLoading : true,
    })),
  on(
    loginFailure,
    loginSuccess,
    signUpSuccess,
    addPropertySuccess,
    scheduleATourSuccess,
    resetPasswordSuccess,
    addTicketReplySuccess,
    getUserDetailsFailure,
    verifyEmailOtpFailure,
    verifyEmailOtpSuccess,
    deactivateUserSuccess,
    changePasswordSuccess,
    deleteUserTicketSuccess,
    createUserTicketSuccess,
    deleteUserPropertySuccess,
    createUserPasswordSuccess,
    getPropertyDetailsFailure,
    getAgentAppointmentsSuccess,
    updateUserProfileImageSuccess,
    contactUsSuccess,
    updateUserTicketStatusSuccess,
    getUserScheduledToursSuccess,
    addRegisterAgentSuccess,
    newsletterSubscribeSuccess,
    contactAgentSuccess,
    updateAgentLeadStatusSuccess,
    updateAgentPortfolioSuccess,
    createAgentOffMarketPropertySuccess,
    getSharedOffMarketPropertySuccess,
    createOrUpdateRentalListingSuccess,
    getRentalListingsSuccess,
    getRentalListingByIdSuccess,
    getPublicRentalListingByIdSuccess,
    startKycIdentitySessionSuccess,
    submitRentalForApprovalSuccess,
    deleteRentalListingSuccess,
    deleteRentalListingFailure,
    searchRentalPropertiesSuccess,
    initiateMarketedListingPaymentSuccess,
    (state): UserState => ({
      ...state,
      isLoading: false,
      isDeactivating: false,
    }),
  ),
  on(
    initiateMarketedListingPaymentFailure,
    (state): UserState => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    setLoadingState,
    (state, { isLoading }): UserState => ({
      ...state,
      isLoading: isLoading,
    }),
  ),
  on(
    addPropertySuccess,
    (state, { data }): UserState => ({
      ...state,
      userPropertyDetails: data,
      isLoading: false,
    }),
  ),
  on(getUserDetailsSuccess, (state, { payload }): any => ({
    ...state,
    details: payload,
    isLoading: false,
    isKycPollingTimedOut: payload?.kycCompleted
      ? false
      : state.isKycPollingTimedOut,
  })),
  on(
    signOutConfirmed,
    (state): UserState => ({
      ...state,
      details: null,
      isKycPolling: false,
      isKycPollingTimedOut: false,
      pendingRentalSubmitAfterKycId: null,
    }),
  ),
  on(
    startKycProfilePolling,
    (state): UserState => ({
      ...state,
      isKycPolling: true,
      isKycPollingTimedOut: false,
    }),
  ),
  on(
    stopKycProfilePolling,
    (state): UserState => ({
      ...state,
      isKycPolling: false,
    }),
  ),
  on(
    kycProfilePollingTimedOut,
    (state): UserState => ({
      ...state,
      isKycPolling: false,
      isKycPollingTimedOut: true,
    }),
  ),
  on(
    clearKycProfilePollingState,
    (state): UserState => ({
      ...state,
      isKycPolling: false,
      isKycPollingTimedOut: false,
    }),
  ),
  on(
    checkKycProfileStatusSuccess,
    (state, { kycCompleted }): UserState => ({
      ...state,
      isKycPollingTimedOut: kycCompleted ? false : state.isKycPollingTimedOut,
    }),
  ),
  on(
    setPendingRentalSubmitAfterKyc,
    (state, { id }): UserState => ({
      ...state,
      pendingRentalSubmitAfterKycId: id,
    }),
  ),
  on(
    submitRentalForApprovalSuccess,
    submitRentalForApprovalFailure,
    (state): UserState => ({
      ...state,
      pendingRentalSubmitAfterKycId: null,
    }),
  ),
  on(
    getUserDetails,
    (state): UserState => ({
      ...state,
      details: {
        ...state.details,
        // isPassword: null,
      },
    }),
  ),
  on(
    signUpFailure,
    addPropertyFailure,
    getAgentLeadsFailure,
    getMarketedAgentLeadsFailure,
    scheduleATourFailure,
    resetPasswordFailure,
    deactivateUserFailure,
    changePasswordFailure,
    addTicketReplyFailure,
    getUserTicketsFailure,
    getUserWishlistFailure,
    getTicketDetailsFailure,
    createUserTicketFailure,
    deleteUserTicketFailure,
    searchPropertiesFailure,
    getUserPropertiesFailure,
    deleteUserPropertyFailure,
    createUserPasswordFailure,
    updateUserProfileImageFailure,
    getMlsPropertyDetailsFailure,
    contactUsFailure,
    getAgentAppointmentsFailure,
    updateUserTicketStatusFailure,
    getUserScheduledToursFailure,
    addRegisterAgentFailure,
    newsletterSubscribeFailure,
    contactAgentFailure,
    updateAgentLeadStatusFailure,
    getAgentContactQueriesFailure,
    getAgentPortfolioFailure,
    updateAgentPortfolioFailure,
    getAgentPayrollSubmissionsFailure,
    getAgentPayrollSubmissionDetailsFailure,
    getAgentOffMarketPropertiesFailure,
    getAgentOffMarketPropertyDetailsFailure,
    createAgentOffMarketPropertyFailure,
    getSharedOffMarketPropertyFailure,
    createOrUpdateRentalListingFailure,
    getRentalListingsFailure,
    getRentalListingByIdFailure,
    getPublicRentalListingByIdFailure,
    startKycIdentitySessionFailure,
    submitRentalForApprovalFailure,
    searchRentalPropertiesFailure,
    getRentalMapMarkersFailure,
    getArisMarketedPropertiesFailure,
    getArisMarketedMapPropertiesFailure,
    (state, { error }) => ({
      ...state,
      error: error,
      isLoading: false,
      isDeactivating: false,
    }),
  ),
  on(
    deactivateUser,
    (state): UserState => ({
      ...state,
      isDeactivating: true,
    }),
  ),
  on(
    getUserPropertiesSuccess,
    (state, { data }): UserState => ({
      ...state,
      properties: data.result,
      isLoading: false,
    }),
  ),
  on(
    getUserWishlistSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      wishList: data.result,
    }),
  ),
  on(
    getPropertyDetailsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      userPropertyDetails: data,
    }),
  ),

  on(getArisMarketedPropertyDetailsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    arisMarketedProperties: {
      ...state.arisMarketedProperties,
      details: data,
    },
  })),

  on(getArisMarketedPropertyDetailsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    arisMarketedProperties: {
      ...state.arisMarketedProperties,
      details: null,
    },
    error: error,
  })),

  on(
    getUserTicketsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      tickets: data?.result ?? [],
    }),
  ),

  on(
    getAgentLeadsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      agentLeads: data?.result ?? [],
    }),
  ),
  on(
    getMarketedAgentLeadsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      marketedAgentLeads: data?.result ?? [],
    }),
  ),
  on(
    getTicketDetailsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      ticketDetails: data.result,
    }),
  ),
  on(
    getTicketRepliesSuccess,
    (state, { data }): UserState => ({
      ...state,
      ticketDetails: {
        ...state.ticketDetails,
        replies: data.result,
      },
    }),
  ),
  on(
    setSearchPropertyRequest,
    (state, { data }): UserState => ({
      ...state,
      mlsProperties: {
        ...state.mlsProperties,
        query: data,
      },
    }),
  ),
  on(
    searchPropertiesSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      mlsProperties: {
        ...state.mlsProperties,
        list: data.result,
      },
    }),
  ),
  on(
    getMlsPropertyDetailsSuccess,
    (state, { data }): UserState => ({
      ...state,
      isLoading: false,
      mlsProperties: {
        ...state.mlsProperties,
        details: data,
      },
    }),
  ),
  on(getAgentAppointmentsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    agentAppointments: data.result,
  })),
  on(getUserScheduledToursSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    scheduledTours: data.result,
  })),
  on(getMessagesSuccess, (state, { data }) => ({
    ...state,
    messages: data,
  })),
  on(setMessage, (state, { data }) => ({
    ...state,
    messages: state.messages.length > 0 ? [...state.messages, data] : [data],
  })),
  on(getMessagesListSuccess, (state, { data }) => ({
    ...state,
    messagesList: data,
  })),
  on(getUserByIdSuccess, (state, { data }) => ({
    ...state,
    messagedUserDetails: data?.result,
  })),
  on(getBlogs, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(getBlogsSuccess, (state, { data }) => ({
    ...state,
    blogs: data?.result,
    pagination: {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    },
  })),
  on(getBlogByIdSuccess, (state, { data }) => ({
    ...state,
    blogDetails: data.result,
  })),
  on(getAllRegisterAgents, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(getAllRegisterAgentsSuccess, (state, { data }) => ({
    ...state,
    allAgents: data?.result,
    isLoading: false,
  })),
  on(getAgentByIdSuccess, (state, { data }) => ({
    ...state,
    agentDetails: data,
  })),
  on(getAddedPropertyInWishListSuccess, (state, { data }) => ({
    ...state,
    addedPropertyInwishList: data,
  })),
  on(getMapPropertiesSuccess, (state, { data }) => ({
    ...state,
    mlsProperties: {
      ...state.mlsProperties,
      mlsMapProperties: data as PropertyMapItem[],
    },
  })),
  on(getYoutubeVideosSuccess, (state, { data }) => ({
    ...state,
    youtubeVideos: data.items,
  })),
  on(getTwitterPostsSuccess, (state, { data }) => ({
    ...state,
    tweets: data,
  })),
  on(getInstagramPostsSuccess, (state, { data }) => ({
    ...state,
    instagramPosts: data.items,
  })),

  on(getAgentContactQueriesSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    contactQueries: data?.data ?? [],
  })),

  on(getAgentPortfolioSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    agentPortfolio: data?.data ?? null,
  })),

  on(getAgentPortfolioFailure, (state, { error }) => ({
    ...state,
    agentPortfolio: null,
  })),

  on(getAgentPayrollSubmissionsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissions: data?.result ?? [],
  })),

  on(getAgentPayrollSubmissionDetailsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissionDetails: data ?? null,
  })),

  on(createAgentPayrollRequestSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissionDetails: data ?? null,
  })),

  on(clearPayrollSubmissionDetails, (state) => ({
    ...state,
    payrollSubmissionDetails: null,
  })),

  on(uploadAgentPayrollDocumentsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissionDetails: state.payrollSubmissionDetails
      ? {
          ...state.payrollSubmissionDetails,
          attachments: [
            ...(state.payrollSubmissionDetails.attachments || []),
            data,
          ],
        }
      : null,
  })),

  on(getAgentOffMarketPropertiesSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    offMarketProperties: {
      ...state.offMarketProperties,
      list: data?.result ?? [],
    },
  })),

  on(
    getAgentOffMarketPropertyDetailsSuccess,
    getSharedOffMarketPropertySuccess,
    (state, { data }) => ({
      ...state,
      isLoading: false,
      offMarketProperties: {
        ...state.offMarketProperties,
        details: data ?? null,
      },
    }),
  ),
  on(getRentalListingsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    rentalListings: data?.result ?? null,
  })),

  on(getRentalListingByIdSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    rentalListingById: data?.result ?? null,
  })),

  on(getRentalListingByIdFailure, (state) => ({
    ...state,
    isLoading: false,
    rentalListingById: null,
  })),

  on(getPublicRentalListingByIdSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    rentalListingById: data?.result ?? null,
  })),

  on(getPublicRentalListingByIdFailure, (state) => ({
    ...state,
    isLoading: false,
    rentalListingById: null,
  })),

  on(searchRentalPropertiesSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    rentalSearchResults: data?.result ?? null,
  })),

  on(getRentalMapMarkersSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    rentalMapMarkers: data ?? [],
  })),

  on(submitRentalForApprovalSuccess, (state, { id }) => ({
    ...state,
    isLoading: false,
    rentalListingById:
      state.rentalListingById?.id === id
        ? { ...state.rentalListingById, status: 'Pending' }
        : state.rentalListingById,
    rentalListings:
      state.rentalListings?.map((listing) =>
        listing.id === id ? { ...listing, status: 'Pending' } : listing,
      ) ?? null,
  })),

  on(deleteRentalListingSuccess, (state, { id }) => ({
    ...state,
    isLoading: false,
    rentalListingById:
      state.rentalListingById?.id === id ? null : state.rentalListingById,
    rentalListings:
      state.rentalListings?.filter((listing) => listing.id !== id) ?? null,
  })),

  on(getArisMarketedPropertiesSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    arisMarketedProperties: {
      ...state.arisMarketedProperties,
      list: data,
    },
  })),

  on(getArisMarketedMapPropertiesSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    arisMarketedProperties: {
      ...state.arisMarketedProperties,
      mapProperties: data,
    },
  })),
  on(markAsSold, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(markAsSoldSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(markAsSoldFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);

export function UserReducer(state: UserState, action: Action) {
  return reducer(state, action);
}
